import { connect } from 'react-redux'
import { selectors, actions } from '../../../../imports'
import { getStatusTexts, getTestServerText, isMenuOpen, toggleMenu } from '../../../../data'
import Server from './component'

function mapStateToProps(state, ownProps) {
    const activeServerId = selectors.getActiveServerId(state)
    const server = selectors.getServer(state, ownProps.serverId)
    const serverStatus = selectors.getServerStatus(state, server.serverId)
    const statusText = getStatusTexts(state)[serverStatus.status]
    const testServerText = getTestServerText(state)
    const locale = selectors.getLocale(state)
    const defaultServer = selectors.getDefaultServer(locale)
    return {
        isActive: ownProps.serverId === activeServerId,
        isTestServer: ownProps.serverId !== defaultServer,
        isOpen: isMenuOpen(state),
        showStatus: serverStatus.numPlayers > 0,
        statusText,
        testServerText,
        ...server,
        status: serverStatus.status,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleMenu: () => {
            dispatch(toggleMenu())
        },
        setActiveServer: (serverId) => {
            dispatch(actions.setActiveServer(serverId))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Server)



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/Server/index.js